import { theme, css } from '../lib';
import { media } from './media-queries';

const defaultGridProperties = css`
  display: grid;
  column-gap: ${theme.space[10]};
`;

export const containerMaxWidth = 1136; // pixels

export const container = css`
  margin: 0 auto;
  padding: 0 ${theme.space[4]};
  position: relative;
  width: 100%;

  ${media.min('xl')`
    max-width: ${containerMaxWidth}px;
  `};
`;

export const containerFluid = css`
  margin-left: auto;
  margin-right: auto;
  padding-left: 0;
  padding-right: 0;
  position: relative;
  width: 100%;
`;

export const grid = {
  size: {
    1: css`
      display: grid;
      grid-template-columns: repeat(1, minmax(0, 1fr));
    `,
    2: css`
      ${defaultGridProperties}
      grid-template-columns: repeat(2, minmax(0, 1fr));
    `,
    3: css`
      ${defaultGridProperties}
      grid-template-columns: repeat(3, minmax(0, 1fr));
    `,
    4: css`
      ${defaultGridProperties}
      grid-template-columns: repeat(4, minmax(0, 1fr));
    `,
    5: css`
      ${defaultGridProperties}
      grid-template-columns: repeat(4, minmax(0, 1fr));

      ${media.max('m')`
        grid-template-columns: repeat(5, minmax(0, 1fr));
      `}
    `,
    6: css`
      ${defaultGridProperties}
      grid-template-columns: repeat(4, minmax(0, 1fr));

      ${media.min('m')`
        grid-template-columns: repeat(6, minmax(0, 1fr));
      `}
    `,
    7: css`
      ${defaultGridProperties}
      grid-template-columns: repeat(4, minmax(0, 1fr));

      ${media.min('m')`
        grid-template-columns: repeat(6, minmax(0, 1fr));
      `}

      ${media.min('l')`
        grid-template-columns: repeat(7, minmax(0, 1fr));
      `}
    `,
    8: css`
      ${defaultGridProperties}
      grid-template-columns: repeat(4, minmax(0, 1fr));

      ${media.min('m')`
        grid-template-columns: repeat(6, minmax(0, 1fr));
      `}

      ${media.min('l')`
        grid-template-columns: repeat(8, minmax(0, 1fr));
      `}
    `,
    9: css`
      grid-template-columns: repeat(4, minmax(0, 1fr));

      ${media.min('m')`
        grid-template-columns: repeat(6, minmax(0, 1fr));
      `}

      ${media.min('l')`
        grid-template-columns: repeat(9, minmax(0, 1fr));
      `}
    `,
    10: css`
      ${defaultGridProperties}
      grid-template-columns: repeat(4, minmax(0, 1fr));

      ${media.min('m')`
        grid-template-columns: repeat(6, minmax(0, 1fr));
      `}

      ${media.min('l')`
        grid-template-columns: repeat(10, minmax(0, 1fr));
      `}
    `,
    11: css`
      ${defaultGridProperties}
      grid-template-columns: repeat(4, minmax(0, 1fr));

      ${media.min('m')`
        grid-template-columns: repeat(6, minmax(0, 1fr));
      `}

      ${media.min('l')`
        grid-template-columns: repeat(11, minmax(0, 1fr));
      `}
    `,
    12: css`
      ${defaultGridProperties}
      grid-template-columns: repeat(4, minmax(0, 1fr));

      ${media.min('m')`
        grid-template-columns: repeat(6, minmax(0, 1fr));
      `}

      ${media.min('l')`
        grid-template-columns: repeat(12, minmax(0, 1fr));
      `}
    `,
  },
  colspan: {
    auto: css`
      grid-column: auto;
    `,
    fluid: css`
      grid-column: -1 / 1;
    `,
    1: css`
      grid-column: auto / span 1;
    `,
    2: css`
      grid-column: auto / span 2;
    `,
    3: css`
      grid-column: auto / span 3;
    `,
    4: css`
      grid-column: auto / span 4;
    `,
    5: css`
      grid-column: auto / span 5;
    `,
    6: css`
      grid-column: auto / span 6;
    `,
    7: css`
      grid-column: auto / span 7;
    `,
    8: css`
      grid-column: auto / span 8;
    `,
    9: css`
      grid-column: auto / span 9;
    `,
    10: css`
      grid-column: auto / span 10;
    `,
    11: css`
      grid-column: auto / span 11;
    `,
    12: css`
      grid-column: auto / span 12;
    `,
  },
};
